import { render, staticRenderFns } from "./VolcanoPlot.vue?vue&type=template&id=3733ec09&scoped=true&"
import script from "./VolcanoPlot.vue?vue&type=script&lang=js&"
export * from "./VolcanoPlot.vue?vue&type=script&lang=js&"
import style0 from "./VolcanoPlot.vue?vue&type=style&index=0&id=3733ec09&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3733ec09",
  null
  
)

export default component.exports